function EditProfile({
  color = 'currentColor',
  size = 21,
  strokeWidth = 0.670909
}: {
  color?: string
  size?: number
  strokeWidth?: number
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.50033 12.9167H6.25033C5.08736 12.9167 4.50587 12.9167 4.03271 13.0602C2.96737 13.3834 2.13369 14.217 1.81053 15.2824C1.66699 15.7555 1.66699 16.337 1.66699 17.5M12.0837 6.25C12.0837 8.32107 10.4047 10 8.33366 10C6.26259 10 4.58366 8.32107 4.58366 6.25C4.58366 4.17893 6.26259 2.5 8.33366 2.5C10.4047 2.5 12.0837 4.17893 12.0837 6.25ZM9.16699 17.5L11.7515 16.7616C11.8752 16.7262 11.9371 16.7085 11.9948 16.682C12.0461 16.6585 12.0948 16.6298 12.1402 16.5965C12.1914 16.5589 12.2369 16.5134 12.328 16.4224L17.7087 11.0417C18.284 10.4664 18.284 9.53362 17.7087 8.95831C17.1334 8.38302 16.2006 8.38303 15.6253 8.95833L10.2446 14.339C10.1536 14.43 10.1081 14.4756 10.0705 14.5267C10.0372 14.5722 10.0085 14.6209 9.98495 14.6722C9.95845 14.7299 9.94077 14.7918 9.90541 14.9155L9.16699 17.5Z" stroke={color} strokeWidth={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>
    </svg> 
  )
}

export default EditProfile
